import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'
// import orderRouter from './order'

const merchantManageRouter = { // 商户管理
  path: '/agentMerchantManage',
  component: Layout,
  redirect: 'agentMerchantManage',
  alwaysShow: true,
  meta: {
    title: '商户管理',
    icon: 'merchant',
    roles: ['agent']
  },
  children: [
    {
      path: 'PlatformMerchant',
      component: resolve => require(['@/views/agent/merchantManage/PlatformMerchant'], resolve),
      name: 'PlatformMerchant',
      meta: { title: '平台商户查询', noCache: false }
    },
    {
      path: 'merchantTransferDetail',
      component: resolve => require(['@/views/agent/merchantManage/merchantTransferDetail'], resolve),
      name: 'MerchantTransferDetail',
      meta: { title: '资金变动', noCache: false }
    }
  ]
}

export default merchantManageRouter



// WEBPACK FOOTER //
// ./src/router/agent/merchantManage.js